module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_DJ_Kysari.ab24f971.jpg";